module.exports = __webpack_public_path__ + "static/media/icon_edit_new.5c089428.svg";